export default __webpack_public_path__ + "static/media/image.a284e488.png";